import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { InputError } from '@foodsby/nutrient'
import { loadEditOrder } from '../../redux/modules/cart'
import { clearMenuItem } from '../../redux/modules/order'
import FriendLabel from '../community/FriendLabel'

export const FriendOrder = ({
  friendFavorite,
  loadEditOrder,
  clearMenuItem,
  children
}) => (
  <Fragment>
    {friendFavorite &&
      friendFavorite.favorites.map((order, i) => (
        <li key={order.orderItemId} className="placeorder-item">
          <div className="row middle-xs">
            <div className="col-xs-2 col-sm-2">
              {i === 0 && (
                <FriendLabel
                  size="large"
                  firstName={friendFavorite.firstName}
                  lastName={friendFavorite.lastName}
                  showName={false}
                  showEmail={false}
                />
              )}
            </div>
            <div className="col-xs-12 col-sm-10">
              <div className="row editPastOrderItem">
                <div className="pastOrderSelector">
                  <button
                    onClick={event => {
                      loadEditOrder(
                        order.hash,
                        null,
                        true,
                        friendFavorite.userId
                      )
                      clearMenuItem()
                    }}
                    className="link pastOrderSelectorButton"
                  >
                    <div className="col-xs-12 placeorder-item_title">
                      {order.displayText}{' '}
                    </div>
                    <div className="col-xs-11 placeorder-item_description">
                      {order.modifiers
                        .map(modifier =>
                          modifier.answers.map(
                            answer => `${answer.displayText}`
                          )
                        )
                        .join(', ')}
                    </div>
                  </button>
                  {i === friendFavorite.favorites.length - 1 && (
                    <div>{children}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </li>
      ))}
  </Fragment>
)

class FriendOrderList extends Component {
  state = { isOpen: false }
  handleClick = event => {
    event.stopPropagation()
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }))
  }

  render() {
    const { friend, loadEditOrder, clearMenuItem } = this.props

    let singleFavorite
    if (friend && friend.favorites.length >= 1) {
      singleFavorite = {
        userId: friend.userId,
        firstName: friend.firstName,
        lastName: friend.lastName,
        favorites: friend.favorites.slice(0, 1)
      }
    }
    return (
      <Fragment>
        <FriendOrder
          friendFavorite={!this.state.isOpen ? singleFavorite : friend}
          loadEditOrder={loadEditOrder}
          clearMenuItem={clearMenuItem}
        >
          {friend && friend.favorites.length > 1 && (
            <button
              className="link showFavoritesLink"
              onClick={this.handleClick}
            >
              Show {!this.state.isOpen ? 'more' : 'less'}
            </button>
          )}
        </FriendOrder>
      </Fragment>
    )
  }
}

class FriendsFavorites extends Component {
  render() {
    const {
      friendsFavorites = [],
      loadEditOrder,
      loadFriendsFavoritesError,
      clearMenuItem,
      filteredFriendsFavorites
    } = this.props
    return (
      <div className="placeorder">
        <div className="favoritePersonalize">
          {friendsFavorites &&
            friendsFavorites.length === 0 &&
            !loadFriendsFavoritesError && (
              <div className="favoriteTitle">
                Your friends do not have any favorites for this item.
              </div>
            )}
          <ul className="placeorder-list">
            {filteredFriendsFavorites &&
              filteredFriendsFavorites.map(friend => (
                <FriendOrderList
                  key={friend.userId}
                  friendsFavorites={friendsFavorites}
                  friend={friend}
                  loadEditOrder={loadEditOrder}
                  clearMenuItem={clearMenuItem}
                />
              ))}
            {loadFriendsFavoritesError && (
              <InputError
                visible={
                  loadFriendsFavoritesError &&
                  loadFriendsFavoritesError !== null
                }
              >
                {loadFriendsFavoritesError}
              </InputError>
            )}
          </ul>
        </div>
      </div>
    )
  }
}
const mapStateToProps = state => {
  const { loadFriendsFavoritesError } = state.friends

  return {
    loadFriendsFavoritesError
  }
}

const mapDispatchToProps = {
  loadEditOrder,
  clearMenuItem
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FriendsFavorites)
